import { render, staticRenderFns } from "./tieba-float-panel-item-view.vue?vue&type=template&id=e12dfbaa&scoped=true&"
import script from "./tieba-float-panel-item-view.vue?vue&type=script&lang=js&"
export * from "./tieba-float-panel-item-view.vue?vue&type=script&lang=js&"
import style0 from "./tieba-float-panel-item-view.vue?vue&type=style&index=0&id=e12dfbaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12dfbaa",
  null
  
)

export default component.exports